<template>
    <!-- custom filter scenario 3 -->
    <!-- customer filter (admin only) & location filter & charger filter & MP filter & custom date -->
    <div class="custom-filter-container pr-20">
        <div class="ml-8 mb-12 session-filter-toolbar">
            <!-- custom filter toggle button -->
            <el-button
            color="#0D3937"
            class="toggle-button"
            @click="displayFilter = !displayFilter"
            >
                <svg class="svg-left width-20 height-20">
                    <use href="@/assets/svg/newSvgIcon.svg#customerFilterButton"></use>
                </svg>
                <span class="moderat-white-bold m-l-10 m-r-10">Custom filter</span>
                <svg v-if="displayFilter" class="svg-right width-20 height-20">
                    <use href="@/assets/svg/newSvgIcon.svg#customFilterArrowClose"></use>
                </svg>
                <svg v-else class="svg-right width-20 height-20">
                    <use href="@/assets/svg/newSvgIcon.svg#customFilterArrowOpen"></use>
                </svg>
            </el-button>
            <div class="session-cache-refresh">
                <el-button
                    v-if="showRefreshButton"
                    color="#ddf0ac"
                    :loading="refreshing"
                    :disabled="refreshing || refreshDisabled"
                    class="height-40 rounded-3 pr-3"
                    @click="$emit('refreshCache')"
                >
                    <svg class="stroke-icon width-20 height-20">
                        <use href="@/assets/svg/icon-sprite.svg#stroke-refresh"></use>
                    </svg>
                    <span class="moderat-btn-apply pl-2"> Refresh data </span>
                </el-button>
                <span v-if="showSessionUpdatedAt" class="session-cache-updated-at">
                    Last updated {{ formattedUpdatedAt }}
                </span>
            </div>
        </div>

        <!-- Custom filter -->
        <el-row v-if="displayFilter">
            <div 
            class="custom-filter-container-wrapper row y-center m-0 mt-2 mb-12 mx-2 p-2 bg-me-primary border-color-light rounded-4 width-100-p"
            >
                <el-form :label-position="`top`" class="custom-filter-form">
                <el-space
                    class="custom-filter-space"
                    fill
                    >

                    <!-- customer list (admin only) -->
                    <el-row gutter="20">
                        <el-col 
                            :span="$vuetify.display.width > 1280 ? 10 : 24" 
                            :class="$vuetify.display.width > 645 ? 'x-start' : 'x-center'" 
                            v-if="
                                $store.state.auth.user != null &&
                                $store.state.auth.user.is_admin
                            "
                        >
                        <el-form-item
                                class="custom-filter-item label-style"
                                prop="customer"
                                label="Customer"
                            >
                                <!-- customer select -->
                                <div>
                                    <el-select 
                                        v-model="filter.customer_id" 
                                        placeholder="Select Customer"  
                                        class="custom-filter-select"
                                        clearable
                                        >
                                        <el-option
                                            v-for="item in customers"
                                            :key="item.id"
                                            :label="item.full_name"
                                            :value="item.id"
                                            >
                                            <span>{{ item.full_name }}</span>
                                            <!-- <span>{{ item.phone }}</span> -->
                                        </el-option>
                                    </el-select>
                                </div>
                            </el-form-item>  
                        </el-col>

                        <el-col 
                        :span="$vuetify.display.width > 1280 ? 10 : 24"
                        :class="$vuetify.display.width > 645 ? 'x-start' : 'x-center' ">
                        <el-form-item
                                class="custom-filter-item label-style"
                                prop="location"
                                label="Electricity Region"
                            >
                                <!-- location select -->
                                <div>
                                <el-tree-select
                                    class="custom-filter-select"
                                    v-model="locationSelection"
                                    :data="treeData"
                                    :render-after-expand="false"
                                    filterable
                                    placeholder="Select country or elec region"
                                    clearable
                                    @change="onTreeLocationChange"
                                >
                                <template #default="{ data }">
                                        <span>{{ data.label.replace("_", " ")}}</span>
                                    </template>
                                </el-tree-select>
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <!-- Location && Charger -->
                    <!-- <el-row gutter="20">
                        <el-col 
                        :span="$vuetify.display.width > 1280 ? 10 : 24" 
                        :class="$vuetify.display.width > 645 ? 'x-start' : 'x-center'" >
                            <el-form-item
                                class="custom-filter-item label-style"
                                prop="location"
                                label="Electricity Region"
                            >
                                <div>
                                <el-tree-select
                                    class="custom-filter-select"
                                    v-model="locationSelection"
                                    :data="treeData"
                                    :render-after-expand="false"
                                    filterable
                                    placeholder="Select country or elec region"
                                    clearable
                                    @change="onTreeLocationChange"
                                >
                                <template #default="{ data }">
                                        <span>{{ data.label.replace("_", " ")}}</span>
                                    </template>
                                </el-tree-select>
                                </div>
                            </el-form-item>
                        </el-col>

                        <el-col 
                        :span="$vuetify.display.width > 1280 ? 10 : 24"
                        :class="$vuetify.display.width > 645 ? 'x-start' : 'x-center' ">
                            <el-form-item
                                class="custom-filter-item label-style"
                                prop="charger"
                                label="Charger"
                            >
                                
                                <div>
                                <el-select
                                    class="custom-filter-select"
                                    v-model="filter.charger_name"
                                    filterable
                                    remote
                                    :remote-method="fetchChargerData"
                                    :loading="chargerLoading"
                                    placeholder="Type to search by charger"
                                    clearable
                                >
                                    <template #prefix>
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M6.5 12C9.53757 12 12 9.53757 12 6.5C12 3.46243 9.53757 1 6.5 1C3.46243 1 1 3.46243 1 6.5C1 9.53757 3.46243 12 6.5 12Z" stroke="#869C9B"/>
                                            <path d="M15 15L11 11" stroke="#869C9B" stroke-linecap="round"/>
                                        </svg>
                                    </template>
                                    <template v-if="chargers.length > 0">
                                        <div class="option-content option-header">
                                            <span class="option-item moderat-meGreen-bold">Charger</span>
                                            <span class="option-item moderat-meGreen-bold">Charging Site</span>
                                        </div>
                                    </template>
                                    <el-option
                                    class="custom-filter-option"
                                    v-for="item in chargers"
                                    :key="item.charger_name"
                                    :label="item.charger_name"
                                    :value="item.charger_name"
                                    >
                                        <div class="option-content option-row">
                                            <span class="option-item-1">{{ item.charger_name }}</span>
                                            <span class="option-item-2">{{ item.site_name }}</span>
                                        </div>
                                    </el-option>
                                </el-select>
                                </div>
                            </el-form-item>
                        </el-col>

                    </el-row> -->

                    <!-- MP filter && custom date -->
                    <el-row gutter="20">
                        <el-col
                        :span="$vuetify.display.width > 1280 ? 10 : 24" 
                        :class="$vuetify.display.width > 645 ? 'x-start' : 'x-center'">
                            <el-form-item
                                class="label-style"
                                prop="mp"
                                label="Monitoring Period"
                            >
                                <!-- MP dropdown -->
                                <div>
                                    <el-select 
                                        v-model="selectedMonitorPeriod.name"
                                        placeholder="Select Monitoring Period" 
                                        class="custom-filter-select"
                                        >
                                        <!-- Render the header row once -->
                                        <template v-if="monitoringPeriods.length > 0">
                                            <div class="option-content option-header" :style="$vuetify.display.width < 470 ? 'max-width: 300px;' : $vuetify.display.width < 800 ? 'max-width: 100%;' : ''">
                                              <span class="option-item">Name</span>
                                              <span class="option-item">Start Date</span>
                                              <span class="option-item">End Date</span>
                                              <span class="option-item">Status</span>
                                            </div>
                                        </template>
                                        <el-option
                                        v-for="(item, index) in monitoringPeriods"
                                        :key="index"
                                        :label="item.name"
                                        :value="item.id"
                                        @click="handleSelectedMP(item.name, item.id, item.status, item.start_date, item.end_date)"
                                        >
                                            <div class="option-content option-row" :style="$vuetify.display.width < 470 ? 'max-width: 300px;' : $vuetify.display.width < 800 ? 'max-width: 100%;' : ''">
                                                <span class="option-item">{{ item.name }}</span>
                                                <span class="option-item">{{ item.start_date.split('T')[0] }}</span>
                                                <span class="option-item">{{ item.end_date.split('T')[0] }}</span>
                                                <span class="option-item">{{ item.status.replaceAll('_', ' ').toUpperCase() }}</span>
                                            </div>
                                        </el-option>
                                        <el-option v-if="!isAuditor" label="Last 7 days" value="Last 7 days" @click="handleSelectedMPName('Last 7 days')">
                                            Last 7 days
                                        </el-option>
                                        <el-option v-if="!isAuditor" label="Last 30 days" value="Last 30 days" @click="handleSelectedMPName('Last 30 days')">
                                            Last 30 days
                                        </el-option>
                                        <el-option v-if="!isAuditor" label="Last 12 months" value="Last 12 months" @click="handleSelectedMPName('Last 12 months')">
                                            Last 12 months
                                        </el-option>
                                        <el-option label="Custom Date" value="custom" @click="displayCustomDate = true">
                                            Custom Date
                                        </el-option>
                                    </el-select>
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col  
                        :span="$vuetify.display.width > 1280 ? 10 : 24" 
                        :class="$vuetify.display.width > 645 ? 'x-start' : 'x-center' ">
                        <el-tooltip
                                    effect="light"
                                    placement="top"
                                    show-after="500"
                                    hide-after="300"
                                    >
                                    <template #content > 
                                        <span :style="{fontSize: '12px', textAlign: 'left'}"> {{ "Select custom date from monitoring period to enable editing" }} </span>
                                    </template>
                            <el-form-item
                                class="custom-filter-item"
                                prop="datetime"
                                label="Datetime"
                            >
                                <!-- date range picker -->
                                <div>
                                    <el-date-picker
                                        class="custom-filter-date-picker"
                                        v-model="dateTimeRange"
                                        type="datetimerange"
                                        :disabled-date="disableAuditorCustomDate"
                                        start-placeholder="Start date"
                                        end-placeholder="End date"
                                        range-separator="To"
                                        format="DD/MM/YYYY HH:mm:ss"
                                        value-format="YYYY-MM-DD HH:mm:ss"
                                        unlink-panels
                                        :disabled="!displayCustomDate"
                                        @change="handleDateRangeChange"
                                    >
                                        <template #prev-month>
                                        <el-icon><CaretLeft /></el-icon>
                                        </template>
                                        <template #next-month>
                                        <el-icon><CaretRight /></el-icon>
                                        </template>
                                        <template #prev-year>
                                        <el-icon>
                                            <svg
                                            viewBox="0 0 20 20"
                                            version="1.1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            >
                                            <g stroke-width="1" fill-rule="evenodd">
                                                <g fill="currentColor">
                                                <path
                                                    d="M8.73171,16.7949 C9.03264,17.0795 9.50733,17.0663 9.79196,16.7654 C10.0766,16.4644 10.0634,15.9897 9.76243,15.7051 L4.52339,10.75 L17.2471,10.75 C17.6613,10.75 17.9971,10.4142 17.9971,10 C17.9971,9.58579 17.6613,9.25 17.2471,9.25 L4.52112,9.25 L9.76243,4.29275 C10.0634,4.00812 10.0766,3.53343 9.79196,3.2325 C9.50733,2.93156 9.03264,2.91834 8.73171,3.20297 L2.31449,9.27241 C2.14819,9.4297 2.04819,9.62981 2.01448,9.8386 C2.00308,9.89058 1.99707,9.94459 1.99707,10 C1.99707,10.0576 2.00356,10.1137 2.01585,10.1675 C2.05084,10.3733 2.15039,10.5702 2.31449,10.7254 L8.73171,16.7949 Z"
                                                />
                                                </g>
                                            </g>
                                            </svg>
                                        </el-icon>
                                        </template>
                                        <template #next-year>
                                        <el-icon>
                                            <svg
                                            viewBox="0 0 20 20"
                                            version="1.1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            >
                                            <g stroke-width="1" fill-rule="evenodd">
                                                <g fill="currentColor">
                                                <path
                                                    d="M11.2654,3.20511 C10.9644,2.92049 10.4897,2.93371 10.2051,3.23464 C9.92049,3.53558 9.93371,4.01027 10.2346,4.29489 L15.4737,9.25 L2.75,9.25 C2.33579,9.25 2,9.58579 2,10.0000012 C2,10.4142 2.33579,10.75 2.75,10.75 L15.476,10.75 L10.2346,15.7073 C9.93371,15.9919 9.92049,16.4666 10.2051,16.7675 C10.4897,17.0684 10.9644,17.0817 11.2654,16.797 L17.6826,10.7276 C17.8489,10.5703 17.9489,10.3702 17.9826,10.1614 C17.994,10.1094 18,10.0554 18,10.0000012 C18,9.94241 17.9935,9.88633 17.9812,9.83246 C17.9462,9.62667 17.8467,9.42976 17.6826,9.27455 L11.2654,3.20511 Z"
                                                />
                                                </g>
                                            </g>
                                            </svg>
                                        </el-icon>
                                        </template>
                                    </el-date-picker>
  
                                </div>
                            </el-form-item>
                            </el-tooltip>
                        </el-col>      
                    </el-row>
                </el-space>
                </el-form>
                <el-row gutter="20" class="custom-filter-button-container float-right mb-20">
                    <el-col :span="24" :class="$vuetify.display.width > 645 ? 'x-start' : 'x-center'">
                    <el-button
                        @click="applyFilter"
                        class="custom-filter-button-apply"
                    >
                        <svg class="width-111 height-40">
                        <use href="@/assets/svg/newSvgIcon.svg#customFilterApplyButton"></use>
                        </svg>
                    </el-button>
                    <el-button
                        @click="resetFilter"
                        class="custom-filter-button-reset"
                    >
                        <svg class="width-112 height-40">
                        <use href="@/assets/svg/newSvgIcon.svg#customFilterResetButton"></use>
                        </svg>
                    </el-button>
                </el-col>
                </el-row>
            </div>
        </el-row>
    </div>
</template>

<script>
import moment from "moment";
import UserService from "../../../services/user.service";
import {
    shorterLabel,
    buildElecRegionTreeData,
    applyTreeLocationSelection,
    formatIsoTimestamp,
    isAuditorUser,
    customersForAccess,
    monitoringPeriodsForAccess,
    monitoringPeriodDateBounds,
    monitoringPeriodRangePickerValue,
    isDateOutsideMonitoringPeriodBounds,
} from "./common-tools";

export default {
    props: {
        periodNameProp: {
            type: String,
            default: "All",
        },
        stateProp: {
            type: Array,
            default: null,
        },
        hasCharger: {
            type: Boolean,
            default: false,
        },
        showRefreshButton: {
            type: Boolean,
            default: false,
        },
        refreshing: {
            type: Boolean,
            default: false,
        },
        refreshDisabled: {
            type: Boolean,
            default: false,
        },
        updatedAt: {
            type: String,
            default: "",
        },
    },
    emits: ["filterHandle", "refreshCache"],
    data() {
        return {
            displayFilter: false, // toggle display of custom filter
            displayCustomDate: false,
            applyMPs: true,
            customers: [],
            countries: [],
            elecRegionsByCountry: {},
            dateTimeRange: [null, null],
            loading: false,
            chargerLoading: false,
            chargers: [],
            options: [], // for location and MP dropdowns
            list: [], // backup list for filtering
            filter: {
                customer_id: null,
                country: "",
                elec_region: "",
                startDate: null,
                endDate: null,
                groupBy: null,
                groupByItem: null,
                charger_name: null,
                mp_id: null,
                status: null,
            },

            locationSelection: "", // Internal selection state for the dropdown
            treeData: [], // Tree structure for countries and elec regions


            hasMPData: true, // control if show MP filter tab, if no data in MP database, use 12 months as MP and hide MP tab buttons

            selectedPeriod: this.periodNameProp,

            optionName: '',
            isAdding: false,

            // Monitoring Periods DATA
            monitoringPeriods: [],

            // data for Monitoring Periods filter button
            selectedMonitorPeriod: {
                id: null,
                name: "current",
                status: null,
                dateTimeRange: [null, null],
            },
        }
    },
    watch: {
        selectedPeriod: {
        handler: function (newValue) {
            this.customDate = false;
            let date = this.dateCalc(newValue);
            this.filter.startDate = date.start_date;
            this.filter.endDate = date.end_date;
            this.dateTimeRange = [date.start_date, date.end_date];
        },
        deep: true,
        },

        'selectedMonitorPeriod.name': {
            handler: function (newValue) {
                if(newValue == "custom") {
                    this.displayCustomDate = true;
                    this.filter.mp_id = null;
                } else {
                    this.displayCustomDate = false;

                    if(newValue == "Last 12 months" || newValue == "Last 30 days" || newValue == "Last 7 days") {
                    this.filter.mp_id = null;
                    this.selectedMonitorPeriod.id = newValue;
                    this.customDate = false;
                    let date = this.dateCalc(newValue);
                    this.filter.startDate = date.start_date + " 00:00:00";
                    this.filter.endDate = date.end_date + " 23:59:59";
                    this.dateTimeRange = [this.filter.startDate, this.filter.endDate];
                }
                }
            },
            deep: true,
        },

        'filter.customer_id': function (newValue) {
            // Convert empty string to null when customer is cleared
            if (newValue === '') {
                this.filter.customer_id = null;
            }
        },
    },

    async mounted() {
        // this.selectedPeriod =
        if (
            this.$store.state.auth.user != null &&
            this.$store.state.auth.user.is_admin
        ) {
            this.fetchCustomerData();
        }

        if (this.applyMPs) {

            await this.fetchMonitoringPeriods();

        } else if (this.periodNameProp == "2023 MP") {
            let date = this.dateCalc(this.periodNameProp);
            this.filter.startDate = date.start_date;
            this.filter.endDate = date.end_date;
            this.dateTimeRange = [date.start_date, date.end_date];
        }

        this.fetchStates();

        // auto apply filter if is client user only
        if (
            this.$store.state.auth.user != null &&
            !this.$store.state.auth.user.is_admin
        ) {
            this.applyFilter();
        }

    },

    methods: {
        // change label to shorter label for fixed button length
        shortLabel(inputLabel,length,MaxLength,additional) {
        let label = shorterLabel(inputLabel,length,MaxLength,additional);
        return label;
        },

        async fetchStates() {
            await UserService.ChargerMapGroupGetStates()
                .then(response => {
                    if (response.data && response.data.data) {
                        this.countries = Object.keys(response.data.data);
                        this.elecRegionsByCountry = response.data.data;
                        this.treeData = buildElecRegionTreeData(this.elecRegionsByCountry);
                    }
                });
        },

        onTreeLocationChange(value) {
            const next = applyTreeLocationSelection(value, this.elecRegionsByCountry);
            this.filter.country = next.country;
            this.filter.elec_region = next.elec_region;
            this.locationSelection = next.locationSelection;
        },

        handleFilterState(event) {
            this.filter.elec_region = event;
        },

        disableAuditorCustomDate(date) {
            if (!this.isAuditor) {
                return false;
            }
            return isDateOutsideMonitoringPeriodBounds(date, monitoringPeriodDateBounds(this.monitoringPeriods));
        },

        isAuditorDateRangeInvalid(value) {
            if (!this.isAuditor || !value || value.length !== 2) {
                return false;
            }
            const bounds = monitoringPeriodDateBounds(this.monitoringPeriods);
            return [value[0], value[1]].some((date) => isDateOutsideMonitoringPeriodBounds(date, bounds));
        },

        handleDateRangeChange(value) {
            const hasRange = value && value.length === 2 && value[0] && value[1];
            if (this.isAuditor && !hasRange) {
                this.resetCustomDateToAvailableRange();
                return;
            }
            if (this.isAuditorDateRangeInvalid(value)) {
                this.$message.warning("Custom date must stay within the available monitoring periods.");
                this.dateTimeRange = [this.filter.startDate, this.filter.endDate];
                return;
            }
            if (hasRange) {
                this.filter.startDate = value[0];
                this.filter.endDate = value[1];
            } else {
                this.filter.startDate = null;
                this.filter.endDate = null;
            }
        },

        resetCustomDateToAvailableRange() {
            const range = monitoringPeriodRangePickerValue(this.monitoringPeriods);
            if (!range) {
                this.$message.warning("Custom date must stay within the available monitoring periods.");
                this.dateTimeRange = [this.filter.startDate, this.filter.endDate];
                return;
            }
            this.filter.startDate = range[0];
            this.filter.endDate = range[1];
            this.$nextTick(() => {
                this.dateTimeRange = [range[0], range[1]];
            });
        },

        keepAuditorCustomDate() {
            if (!this.isAuditor || this.selectedMonitorPeriod.name !== "custom") {
                return true;
            }
            if (this.filter.startDate && this.filter.endDate) {
                return true;
            }
            this.resetCustomDateToAvailableRange();
            return Boolean(this.filter.startDate && this.filter.endDate);
        },

        async fetchCustomerData() {
            this.loading = true;
            await UserService.getCustomers(null)
                .then(
                (response) => {
                    if (!response || !response.data || !response.data.customers) {
                        this.customers = [];
                    } else {
                        this.customers = customersForAccess(response.data.customers, this.$store.state.auth.user);
                    }
                },
                (error) => {
                    this.loading = false;
                    console.log(error.message);
                    if (error.response.status == 401) {
                    this.$router.push({
                        path: "/",
                    });
                    }
                }
                )
                .catch((error) => {
                this.loading = false;
                console.log(error.message);
                if (error.response.status == 401) {
                    this.$router.push({
                    path: "/",
                    });
                }
                })
                .finally(() => (this.loading = false));
        },

        handleSelectedMPName(name) {
            this.selectedMonitorPeriod.name = name;
        },

        async fetchMonitoringPeriods() {
            const parseAndSetMonitoringPeriod = (mp) => {
                this.selectedMonitorPeriod.name = mp.name;
                this.selectedMonitorPeriod.id = mp.id;
                this.selectedMonitorPeriod.status = mp.status;
                this.filter.mp_id = mp.id;
                this.filter.status = mp.status;
                this.filter.startDate = String(mp.start_date).replace("T", " ").substring(0, 19);
                this.filter.endDate = String(mp.end_date).replace("T", " ").substring(0, 19);
                this.dateTimeRange = [this.filter.startDate, this.filter.endDate];
            };

            const findLatestMP = (list, status) => {
                const filtered = list.filter(mp => mp.status === status);
                if (filtered.length > 0) {
                return filtered.sort((a, b) => new Date(b.start_date) - new Date(a.start_date))[0];
                }
                return null;
            };

            const fallbackToFirst = async (monitoringPeriods) => {
                console.log("Both Current and Under audit Monitoring Period not found.");
                
                const fallback = monitoringPeriods[0];
                console.log("Fallback to first MP: ", fallback.name, fallback.start_date, fallback.end_date);
                parseAndSetMonitoringPeriod(fallback);
            };

            const handleMPSelection = async (monitoringPeriods) => {
                monitoringPeriods = monitoringPeriodsForAccess(monitoringPeriods, this.$store.state.auth.user);
                this.monitoringPeriods = monitoringPeriods;

                // 1. Try "current"
                let mp = findLatestMP(this.monitoringPeriods, "current");

                // 2. If not found, try "under_audit"
                if (!mp) {
                mp = findLatestMP(this.monitoringPeriods, "under_audit");
                }

                if (mp) {
                console.log("Selected MP: ", mp.name, mp.start_date, mp.end_date);
                parseAndSetMonitoringPeriod(mp);
                } else if (monitoringPeriods.length > 0) {
                await fallbackToFirst(this.monitoringPeriods);
                }
            };

            // Fetch from API (session cache omitted — not scoped by project_id)
            try {
                
                const response = await UserService.getMonitoringPeriods(null, "", 1, 50, true);
                const data = response.data.monitoring_periods || [];

                if (data.length > 0) {
                sessionStorage.setItem("monitoringPeriods", JSON.stringify(data));
                await handleMPSelection(data);
                } else {
                // no data in MP database, set selected mp name to '12 months'
                console.log('Monitoring periods data is empty, use 12 months instead');
                this.hasMPData = false;
                this.selectedMonitorPeriod.name = 'Year';
                this.loading = false;
                return;
                }
            } catch (error) {
                this.loading = false;
                console.error("Monitoring periods fetch error:", error.message);
                if (error.response?.status === 401) {
                this.$router.push({ path: "/" });
                }
            } finally {
                this.loading = false;
            }
        },

        handleSelectedMP(name, id, status, start_date, end_date) {
            this.selectedMonitorPeriod.name = name;
            this.selectedMonitorPeriod.id = id;
            this.selectedMonitorPeriod.status = status;
            this.selectedMonitorPeriod.start_date = String(start_date).replace("T", " ").substring(0, 19);
            this.selectedMonitorPeriod.end_date = String(end_date).replace("T", " ").substring(0, 19);
            this.filter.startDate = this.selectedMonitorPeriod.start_date;
            this.filter.endDate = this.selectedMonitorPeriod.end_date;
            this.filter.mp_id = id;
            this.filter.status = status;
            this.dateTimeRange = [this.filter.startDate, this.filter.endDate];
        },

        onAddOption() {
            this.isAdding = true
        },

        onConfirm() {
        if (this.optionName) {
            this.monitoringPeriods.push({
            label: this.optionName,
            value: this.optionName,
            })
            this.clear()
        }
        },

        clear() {
            this.optionName = ''
            this.isAdding = false
        },

        dateCalc(period) {
            let current = moment().format("yyyy-MM-DD");
            if (period == "Today") {
                return {
                start_date: current,
                end_date: current,
                };
            } else if (period == "Last 7 days") {
                return {
                start_date: moment(current).subtract(1, "w").format("yyyy-MM-DD"),
                end_date: current,
                };
            } else if (period == "Last 30 days") {
                return {
                start_date: moment(current).subtract(1, "M").format("yyyy-MM-DD"),
                end_date: current,
                };
            } else if (period == "Last 12 months") {
                return {
                start_date: moment(current).subtract(1, "y").format("yyyy-MM-DD"),
                end_date: current,
                };
            } else if (period == "All") {
                return {
                start_date: null,
                end_date: null,
                };
            }
        },

        // async fetchChargerData(search) {
        //     // console.log(search);
        //     if (search.length > 0) {
        //         this.chargerLoading = true;
        //         let body = {
        //         customer_id: this.filter.customer_id,
        //         search: search,
        //         project_id: this.latestSelectedProject?.id || null,
        //         };
        //         await UserService.GetChargerSelection(body)
        //         .then(
        //             (response) => {
        //             this.chargers = response.data.chargers;
        //             },
        //             (error) => {
        //             this.chargerLoading = false;
        //             console.log(error);
        //             if (error.response.status == 401) {
        //                 this.$router.push({
        //                 path: "/",
        //                 });
        //             }
        //             }
        //         )
        //         .catch((error) => {
        //             this.chargerLoading = false;
        //             console.log(error);
        //             if (error.response.status == 401) {
        //             this.$router.push({
        //                 path: "/",
        //             });
        //             }
        //         })
        //         .finally(() => (this.chargerLoading = false));
        //     }
        // },

        applyFilter() {
            if (!this.keepAuditorCustomDate()) {
                return;
            }
            if(this.selectedMonitorPeriod.name != "custom") {
                this.displayCustomDate = false;
            } else {
                this.displayCustomDate = true;
            }
            const mpName = this.selectedMonitorPeriod.name;
            const isNonMpRange =
                mpName == "custom" ||
                mpName == "Last 12 months" ||
                mpName == "Last 30 days" ||
                mpName == "Last 7 days";
            const mpId = this.selectedMonitorPeriod.id;
            this.filter.mp_id =
                !isNonMpRange && mpId != null && mpId !== "" && Number.isFinite(Number(mpId))
                    ? mpId
                    : null;
            this.filter.status = this.selectedMonitorPeriod.status ?? this.filter.status;
            this.$emit("filterHandle", this.filter);
        },

        async resetFilter() {
            this.displayCustomDate = false;
            this.chargers = [];
            this.locationSelection = "";

            this.filter = {
                customer_id: null,
                country: "",
                elec_region: "",
                startDate: null,
                endDate: null,
                groupBy: null,
                groupByItem: null,
                charger_name: null,
                mp_id: null,
                status: null,
            };
            this.dateTimeRange = [null, null];

            await this.fetchStates();

            if (
                this.$store.state.auth.user != null &&
                this.$store.state.auth.user.is_admin
            ) {
                await this.fetchCustomerData();
            }

            if (this.applyMPs) {
                await this.fetchMonitoringPeriods();
            } else if (this.periodNameProp == "2023 MP") {
                const date = this.dateCalc(this.periodNameProp);
                this.filter.startDate = date.start_date;
                this.filter.endDate = date.end_date;
                this.dateTimeRange = [date.start_date, date.end_date];
            }

            this.$emit("filterHandle", this.filter);
        },
    },

    computed: {
        isAuditor() {
            return isAuditorUser(this.$store.state.auth.user);
        },
        formattedUpdatedAt() {
            return formatIsoTimestamp(this.updatedAt);
        },
        showSessionUpdatedAt() {
            return Boolean(this.formattedUpdatedAt);
        },
        dayMonthYear() {
            return [
                { text: 'Last 7 days', value: [moment().subtract(7, 'days').toDate(), new Date()] },
                { text: 'Last 30 days', value: [moment().subtract(30, 'days').toDate(), new Date()] },
                { text: 'Last 12 months', value: [moment().subtract(12, 'months').toDate(), new Date()] },
            ];
        },
    },
}
</script>

<style scoped>
  .session-filter-toolbar {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;
  }
  .session-cache-refresh {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    margin-left: auto;
    gap: 4px;
  }
  .session-cache-updated-at {
    font-size: 12px;
    color: #ffffff;
    line-height: 1.4;
    white-space: nowrap;
  }
  .option-content {
    display: flex;
    justify-content: space-between;
    align-items: justify;
    width: 100%;
  }

  .option-header {
    position: sticky;
    top:0;
    z-index: 1;
    background-color: #f2f2f2;
    border-radius: 10px;
  }

  .option-item {
    font-size: 13px;
    flex: 1;
    text-align: center;
    padding: 4px;
  }

  .option-item-1 {
    font-size: 13px;
    flex: 1;
    text-align: start;
    padding: 4px;
  }

  .option-item-2 {
    font-size: 13px;
    flex: 1;
    text-align: end;
    padding: 4px;
  }
</style>